import { PageController } from '@client/components/_core/layout/PageController';
import { DocumentUpload } from '@client/components/tools/document-analyzer/DocumentUpload';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/tools/document-analyzer/upload')({
    staticData: {
        breadcrumb: {
            title: 'Upload document',
        },
    },
    component: UploadPage,
});

function UploadPage() {
    return (
        <PageController route={Route}>
            <div className="p-6">
                <div className="mx-auto max-w-4xl">
                    <div className="mb-6">
                        <h2 className="font-semibold text-2xl text-foreground">Upload document for analysis</h2>
                        <p className="mt-2 text-muted-foreground text-sm">
                            Upload a document to automatically detect potential regulatory breaches. Currently supported
                            documents: FSG (Financial Services Guide), complaints policy, and conflict of interest
                            policy.
                        </p>
                    </div>

                    <DocumentUpload />
                </div>
            </div>
        </PageController>
    );
}
